import { useState, useCallback } from "react";
import fileclose from "../../assets/img/fileclose.png";
import dayjs from "dayjs";

const useFindSelectedNode = () => {
    const [selectedNodeData, setSelectedNodeData] = useState(null);

    const findSelectedNode = useCallback((apiData, breadKey) => {
        if (!apiData || apiData.length === 0) return [];

        const dataMap = {};
        apiData.forEach(item => {
            dataMap[item.id] = item;
        });

        // 🔄 Step 2: Recursively find permissions from parent if not present
        const getInheritedPermissions = (node) => {
            if (node?.permissions) return node.permissions;

            let current = node;
            while (current && !current.permissions) {
                current = dataMap[current.parent_id];
            }
            return current?.permissions || [];
        };

        const buildTreeNode = (node) => ({
            selected_type: node.selected_type,
            title: node.folder_name,
            document_file_name: node.document_file_name,
            document_file_path: node.document_file_path,
            document_thambnail_path: node.document_thambnail_path,
            parent_id: node.parent_id,
            is_fav: node?.is_fav,
            commit_count: node?.commit_count,
            is_locked: node?.is_locked,
            key: node.id,
            document_title: node?.document_title,
            permissions: node?.permissions ? node?.permissions : getInheritedPermissions(node),
            document_thambnail_path: node?.document_thambnail_path,
            created_at: dayjs(node?.created_at).format('YYYY-MM-DD HH:mm:ss'),
            icon: <img src={fileclose} width={17} alt='' loading='lazy' />,
            children: [],
        });

        const buildTree = (parentId, visited = {}) => {
            if (visited[parentId]) return [];
            visited[parentId] = true;

            return apiData
                .filter(child => child.parent_id === parentId)
                .map(child => ({
                    ...buildTreeNode(child),
                    children: buildTree(child.id, visited),
                }));
        };

        const selectedNode = apiData.find(node => node.id === (breadKey || selectedNodeData?.key));
        if (!selectedNode) return [];

        return [{
            ...buildTreeNode(selectedNode),
            children: buildTree(selectedNode.id),
        }];
    }, [selectedNodeData]); // ✅ Add dependency

    return { findSelectedNode, selectedNodeData, setSelectedNodeData };
};

export default useFindSelectedNode;
